import { Component, inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef
} from "@angular/material/dialog";
import { MatButton } from "@angular/material/button";
import { TranslatePipe } from "@ngx-translate/core";
import { MatToolbar, MatToolbarRow } from "@angular/material/toolbar";

@Component({
  selector: "app-delete-preset-dialog",
  templateUrl: "./delete-preset-dialog.component.html",
  styleUrls: ["./delete-preset-dialog.component.css"],
  standalone: true,
  imports: [
    MatToolbar,
    MatToolbarRow,
    MatDialogModule,
    MatButton,
    TranslatePipe
  ]
})
export class DeletePresetDialogComponent {
  dialogRef = inject<MatDialogRef<DeletePresetDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  confirm() {
    this.dialogRef.close({
      confirm: true,
      id: this.data.id
    });
  }
}
